import { WIND_RAMP_KMH } from "@divespots/contracts";

/** Wind speed classes of the legend and the arrow grid: < 10, 10–20, 20–35, ≥ 35 km/h → `--wind-0..3`. */
export const WIND_CLASS_LIMITS_KMH = WIND_RAMP_KMH;

/** Speed is never colour-only: reduced-motion arrows (and the legend) grow with the band. */
export const ARROW_LENGTH_PX = [14, 20, 26, 32] as const;
export const ARROW_WEIGHT_PX = [1.5, 2, 2.5, 3] as const;
/** Halo around every arrow, in px per side (the colour ramp alone fails 3:1 on the map). */
export const ARROW_HALO_PX = 1.5;
export type WindClass = 0 | 1 | 2 | 3;

export const msToKmh = (ms: number): number => ms * 3.6;

export function windClass(speedMs: number): WindClass {
  const kmh = msToKmh(speedMs);
  if (kmh < WIND_CLASS_LIMITS_KMH[0]) return 0;
  if (kmh < WIND_CLASS_LIMITS_KMH[1]) return 1;
  if (kmh < WIND_CLASS_LIMITS_KMH[2]) return 2;
  return 3;
}

export const windVar = (c: WindClass): string => `--wind-${c}`;
